export default __webpack_public_path__ + "static/media/offer5.9a617b72.jpg";